/**
 * Converts a params object into URLSearchParams, omitting null/undefined entries.
 * Values are coerced to strings (e.g. `year: 2024` → `"2024"`).
 */
export const buildQueryParams = (params: Record<string, string | number | undefined | null>): URLSearchParams => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value != null) {
            queryParams.set(key, String(value));
        }
    });
    return queryParams;
};
